<template lang="pug">
.page-wrapper
    StaticElements
    .static-navigation-buttons
        .back-to-top(@click="BackToTop", :class="{ hidden: isAtTop }")
            span.lnr.lnr-chevron-up
            span.lnr.lnr-chevron-up
        span.navbutton.lnr.lnr-chevron-up(
            @click="SlideUp",
            :class="{ hidden: isAtTop }"
        )
        span.navbutton.lnr.lnr-chevron-down(
            @click="SlideDown",
            :class="{ hidden: isAtBottom }"
        )
    full-page(:options="fpOptions", ref="fullpage")
        .section(data-anchor="landing")
            HomeBanner
        .section(data-anchor="about")
            .section-wrapper
                VRow.section-inner-wrapper
                    VCol(:variants="['xs-12', 'lg-4']")
                        .section-image(ref="parallax1")
                            img.main-image(
                                src="@/assets/images/teammembers.jpg",
                                data-depth="0.3"
                            )
                            img.dot-pattern(
                                src="@/assets/dot-pattern.svg",
                                data-depth="0.05"
                            )
                            .outline-square(data-depth="0.15")
                    VCol.section-content-container(
                        :variants="['xs-12', 'lg-8']"
                    )
                        h1.section-title Design, Development &<br/> Production Studio
                        .section-content-wrapper
                            .section-subtitle
                                span.line
                                | Our mission
                            .section-content
                                p Founded in 2020, Influx Studios consists of a passionate team of creatives and developers, offering a wide variety of services to our clients to bring their ideas to market.
                                p We honour ourselves on the quality of work delivered, ensuring all work is well-rounded and polished. We go above-and-beyond to ensure our clients are happy and receive their work in a timely manner.
                                .service-list
                                    .service-item
                                        span.numbering 01
                                        span.label Design
                                        span.lnr.lnr-chevron-right 
                                    .service-item
                                        span.numbering 02
                                        span.label Development
                                        span.lnr.lnr-chevron-right.expended 
                                    .service-item
                                        span.numbering 03
                                        span.label Production
                                        span.lnr.lnr-chevron-right 
                .section-gridlines
        .section(data-anchor="services")
            .section-wrapper
                VRow.section-inner-wrapper
                    VCol(:variants="['xs-12', 'lg-4']")
                        .section-image(ref="parallax2")
                            img.main-image(
                                src="@/assets/images/tech.jpg",
                                data-depth="0.3"
                            )
                            img.dot-pattern(
                                src="@/assets/dot-pattern.svg",
                                data-depth="0.05"
                            )
                            .filled-squares(data-depth="0.15")
                    VCol.section-content-container(
                        :variants="['xs-12', 'lg-8']"
                    )
                        h1.section-title What do we do?
                        VRow.section-content-wrapper
                            VCol(:variants="['xs-12', 'lg-6']")
                                .section-subtitle
                                    span.line
                                    | Frontend Development
                                .section-content
                                    ul
                                        li React.js & Vue.js
                                        li HTML, SCSS, JavaScript
                                        li Performance & Accessibility
                                        li UI Design
                                        li User Experience
                                .spacer
                                .section-subtitle
                                    span.line
                                    | Backend Development
                                .section-content
                                    ul
                                        li PHP, MySQL, Linux
                                        li Node.js
                                        li REST APIs & Documentation
                                        li Container Orchestration
                            VCol(:variants="['xs-12', 'lg-6']")
                                .section-subtitle
                                    span.line
                                    | Content Creation
                                .section-content
                                    ul
                                        li Film Production
                                        li Graphic Design
                                        li Illustration
                                        li Post-Production
                                        li.hidden Studio Photography
                                .spacer
                                .section-subtitle
                                    span.line
                                    | Mobile Development
                                .section-content
                                    ul
                                        li Cordova, Capacitor, Ionic
                                        li Flutter, Dart
                                        li Usability Testing
                                        li Deployment
                .section-gridlines
        .section.featured-works-section(
            data-anchor="works",
            ref="featuredWorks"
        )
            .section-wrapper
                .section-inner-wrapper
                    .section-content-container
                        .section-title-with-button
                            h1.section-title Featured Works
                            router-link.primary-button(
                                to="/works",
                                data-cursor-shrink
                            ) Explore our Works
                        .section-content-wrapper
                            VRow
                                VCol(:variants="['xs-12', 'lg-4']")
                                    #fi1.featured-work-image-wrapper
                                        router-link(to="/works/vitaminsea")
                                            DisplacementImage(
                                                :width="512",
                                                aspectRatio="1:1",
                                                :image1="require('@/assets/images/vitaminsea/mockup2-bnw.jpg')",
                                                :image2="require('@/assets/images/vitaminsea/mockup2.jpg')",
                                                :displacement="require('@/assets/images/displacement2.jpg')",
                                                :shiftFactor="0.05",
                                                data-cursor-shrink
                                            )
                                        .outline-square.square-1
                                        .filled-square.square-1
                                    .featured-work-details
                                        h4.featured-work-subtitle University of Pretoria
                                        h3.featured-work-title Beach Accommodation Made Easy
                                VCol(:variants="['xs-12', 'lg-4']")
                                    #fi2.featured-work-image-wrapper
                                        router-link(to="/works/swift")
                                            DisplacementImage(
                                                :width="512",
                                                aspectRatio="1:1",
                                                :image1="require('@/assets/images/swift-mockups/smockup-bnw.jpg')",
                                                :image2="require('@/assets/images/swift-mockups/smockup.jpg')",
                                                :displacement="require('@/assets/images/displacement2.jpg')",
                                                :shiftFactor="0",
                                                data-cursor-shrink
                                            )
                                        img.dot-pattern(
                                            src="@/assets/dot-pattern.svg"
                                        )
                                        .outline-square.square-2
                                    .featured-work-details
                                        h4.featured-work-subtitle University of Pretoria
                                        h3.featured-work-title Intuitive Restaurant Point-of-Sale System
                                VCol(:variants="['xs-12', 'lg-4']")
                                    #fi3.featured-work-image-wrapper
                                        router-link(to="/works/diamond")
                                            DisplacementImage(
                                                :width="512",
                                                aspectRatio="1:1",
                                                :image1="require('@/assets/images/pioneer-mockup-bnw.jpg')",
                                                :image2="require('@/assets/images/pioneer-mockup.jpg')",
                                                :displacement="require('@/assets/images/displacement2.jpg')",
                                                :shiftFactor="0",
                                                data-cursor-shrink
                                            )
                                        .outline-square.square-3
                                        .outline-square.square-4
                                        .filled-square.square-2
                                    .featured-work-details
                                        h4.featured-work-subtitle Pioneer Diamond Tendering House
                                        h3.featured-work-title Secure Diamond Tendering Platform
                .section-gridlines
        .section.team-bg(data-anchor="team")
            VueSlickCarousel(
                ref="teamsCarousel",
                :arrows="false",
                :dots="false"
            )
                .team-section
                    .section-wrapper
                        VRow.section-inner-wrapper
                            VCol.section-image(:variants="['xs-12', 'lg-4']")
                                .team-image
                                    img.person(src="@/assets/images/ruben.png")
                                    img.bg(src="@/assets/team-bg.svg")
                                .team-person-details
                                    h3 Ruben Schoeman
                                    h4 Fullstack Developer
                                .team-person-contacts
                                    a(href="mailto:hello@rubenschoeman.com") hello@rubenschoeman.com
                                    a(href="tel:+27767449579") +27 76 744 9579
                                .team-person-socials
                                    a.contact-info-social(
                                        href="https://github.com/Ruben-Schoeman",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/github.svg")
                                    a.contact-info-social(
                                        href="https://instagram.com/ruben.schoeman_",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/insta.svg")
                                    a.contact-info-social(
                                        href="https://www.linkedin.com/in/rubenschoeman/",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/linkedin.svg")
                                .team-navigation-links
                                    span.lnr.lnr-chevron-left.team-prev(
                                        data-cursor-sticky,
                                        @click="prevTeamMember"
                                    )
                                    .team-navigation-indicator
                                        span.number 1
                                        span.divider /
                                        span.number 3
                                    span.lnr.lnr-chevron-right.team-next(
                                        data-cursor-sticky,
                                        @click="nextTeamMember"
                                    )
                            VCol.section-content-container(
                                :variants="['xs-12', 'lg-8']"
                            )
                                h1.section-title Meet the Team
                                .section-content-wrapper
                                    blockquote.team-person-quote
                                        | “Success is not measured by wealth. Success is measured by the passion for what you do and your willingness to learn. You need to grow your skillset, build lasting relationships, and gain lifechanging experience along the way.”
                                    p.team-person-description
                                        | I develop using powerful modern technologies, incorporating easily maintainable architectures and design patterns. All development is done in a way that is sustainable and easy to work with, while maintaining unmatched performance and efficiency.
                                        | <br/><br/>Designs are built upon strong foundational UI/UX concepts and techniques, ensuring the final product is polished and easy to use. This is accomplished through a multi-tier design process including both low- and high-fidelity mockups.
                                    TabbedView
                                        .tabbed-content(data-id="0")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li HTML, CSS3
                                                            li SASS/SCSS
                                                            li JavaScript, Vue.js, React.js
                                                            li Webpack, Pug
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Cordova, Flutter, Dart
                                                            li Node.js, PHP
                                                            li MySQL, Mongodb
                                                            li Linux, Nginx, Apache, Security
                                        .tabbed-content(data-id="1")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Branding
                                                            li Corporate Identity
                                                            li UI Design
                                                            li User Experience
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Low- and High-Fidelity Mockups
                                                            li Adobe Suite
                                                            li Videography, Photography
                                                            li.hidden 
                                        .tabbed-content(data-id="2")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Photography
                                                            li Videography
                                                            li Video Editing
                                                            li Flight Simulators
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Reading
                                                            li Exploration, Travel
                                                            li.hidden
                                                            li.hidden 
                                        .tabbed-content(data-id="3")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Home Page Design &amp; Development
                                                            li Branding
                                                            li Reusable Components
                                                            li Interactivity
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Project Structuring
                                                            li Wireframes &amp; Mockups
                                                            li Hosting &amp; Server Setup
                                                            li.hidden 
                        .section-gridlines
                .team-section
                    .section-wrapper
                        VRow.section-inner-wrapper
                            VCol.section-image(:variants="['xs-12', 'lg-4']")
                                .team-image
                                    img.person(src="@/assets/images/cadon.png")
                                    img.bg(src="@/assets/team-bg.svg")
                                .team-person-details
                                    h3 Cadon Gernandt
                                    h4 Multimedia Designer
                                .team-person-contacts
                                    a(href="mailto:cadongernandt@gmail.com") cadongernandt@gmail.com
                                .team-person-socials
                                    a.contact-info-social(
                                        href="https://github.com/cadongernandt",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/github.svg")
                                .team-navigation-links
                                    span.lnr.lnr-chevron-left.team-prev(
                                        data-cursor-sticky,
                                        @click="prevTeamMember"
                                    )
                                    .team-navigation-indicator
                                        span.number 2
                                        span.divider /
                                        span.number 3
                                    span.lnr.lnr-chevron-right.team-next(
                                        data-cursor-sticky,
                                        @click="nextTeamMember"
                                    )
                            VCol.section-content-container(
                                :variants="['xs-12', 'lg-8']"
                            )
                                h1.section-title Meet the Team
                                .section-content-wrapper
                                    blockquote.team-person-quote
                                        | "When opportunity comes it is too late to prepare." - John Wooden
                                    p.team-person-description
                                        | I am currently a 3rd year Multimedia student at the University of Pretoria who enjoys designing and implementing Multimedia systems. I am a highly driven, entrepreneurial individual and am currently working with a team that offers a variety of services to clients such as branding, digital marketing, web and mobile development.<br/><br/>I have worked in an amalgamation of multimedia fields such as web design, game development, graphic and visual design, application creation, animation, 3d modeling, video and photo editing. I enjoy creating IoT projects as well as composing music.
                                    TabbedView
                                        .tabbed-content(data-id="0")
                                            VGrid(variant="container")
                                                VRow
                                                    VCol(
                                                        :variants="['xs-12', 'md-6']"
                                                    )
                                                        p.person-skills
                                                            ul.skill-list
                                                                li Web Development
                                                                li Mobile Development
                                                                li.hidden
                                                                li.hidden
                                                    VCol(
                                                        :variants="['xs-12', 'md-6']"
                                                    )
                                                        p.person-skills
                                                            ul.skill-list
                                                                li Game Development
                                                                li Animation
                                                                li.hidden
                                                                li.hidden
                                        .tabbed-content(data-id="1")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Brand Strategy
                                                            li UI Design
                                                            li UX Design
                                                            li.hidden
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Motion Design
                                                            li Graphic Design
                                                            li.hidden
                                                            li.hidden 
                                        .tabbed-content(data-id="2")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Entrepreneurship
                                                            li Music Composition
                                                            li.hidden
                                                            li.hidden
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Drawing
                                                            li.hidden
                                                            li.hidden
                                                            li.hidden 
                                        .tabbed-content(data-id="3")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Branding
                                                            li Stylescapes
                                                            li.hidden
                                                            li.hidden
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Design + Implementation of Portfolio Works
                                                            li.hidden
                                                            li.hidden
                                                            li.hidden 
                        .section-gridlines
                .team-section
                    .section-wrapper
                        VRow.section-inner-wrapper
                            VCol.section-image(:variants="['xs-12', 'lg-4']")
                                .team-image
                                    img.person(src="@/assets/images/sean.png")
                                    img.bg(src="@/assets/team-bg.svg")
                                .team-person-details
                                    h3 Sean Loock
                                    h4 Multimedia Designer
                                .team-person-contacts
                                    a(
                                        href="mailto:seanloockservices@gmail.com"
                                    ) seanloockservices@gmail.com
                                .team-person-socials
                                    a.contact-info-social(
                                        href="https://www.facebook.com/sean.loock/",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/facebook.svg")
                                    a.contact-info-social(
                                        href="https://www.instagram.com/seanloock/",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/insta.svg")
                                    a.contact-info-social(
                                        href="https://www.linkedin.com/in/sean-loock-08076a158/",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/linkedin.svg")
                                .team-navigation-links
                                    span.lnr.lnr-chevron-left.team-prev(
                                        data-cursor-sticky,
                                        @click="prevTeamMember"
                                    )
                                    .team-navigation-indicator
                                        span.number 3
                                        span.divider /
                                        span.number 3
                                    span.lnr.lnr-chevron-right.team-next(
                                        data-cursor-sticky,
                                        @click="nextTeamMember"
                                    )
                            VCol.section-content-container(
                                :variants="['xs-12', 'lg-8']"
                            )
                                h1.section-title Meet the Team
                                .section-content-wrapper
                                    blockquote.team-person-quote
                                        | "Design adds value faster than it adds costs." - Joel Spolsky
                                    p.team-person-description
                                        | Currently in my final year studying BIS Multimedia at the University of Pretoria. I have experience in video editing, software engineering, game development and graphic design. I've worked on frontend and backend web design and development and have created several video projects for local South African companies. I am currently doing all the graphic design and web development work for a South African finance education startup company.
                                    TabbedView
                                        .tabbed-content(data-id="0")
                                            VGrid(variant="container")
                                                VRow
                                                    VCol(
                                                        :variants="['xs-12', 'md-6']"
                                                    )
                                                        p.person-skills
                                                            ul.skill-list
                                                                li Web Development
                                                                li Game Development
                                                                li.hidden
                                                                li.hidden
                                                    VCol(
                                                        :variants="['xs-12', 'md-6']"
                                                    )
                                                        p.person-skills
                                                            ul.skill-list
                                                                li Software Development
                                                                li.hidden
                                                                li.hidden
                                                                li.hidden
                                        .tabbed-content(data-id="1")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Web/Mobile UI Design
                                                            li Web/Mobile UX Design
                                                            li.hidden
                                                            li.hidden
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Branding/Rebranding
                                                            li.hidden
                                                            li.hidden
                                                            li.hidden 
                                        .tabbed-content(data-id="2")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Swimming
                                                            li Piano
                                                            li.hidden
                                                            li.hidden
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li.hidden
                                                            li.hidden
                                                            li.hidden
                                                            li.hidden 
                                        .tabbed-content(data-id="3")
                                            VRow
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li Design + Development of Works Page
                                                            li Wireframing
                                                            li.hidden
                                                            li.hidden
                                                VCol(
                                                    :variants="['xs-12', 'md-6']"
                                                )
                                                    p.person-skills
                                                        ul.skill-list
                                                            li.hidden
                                                            li.hidden
                                                            li.hidden
                                                            li.hidden 
                        .section-gridlines
        .section(data-anchor="contact")
            .section-wrapper
                .section-inner-wrapper
                    .section-content-container
                        h1.section-title Let us help bring your ideas to market!
                        VRow.section-content-wrapper
                            VCol(:variants="['xs-12', 'md-6']")
                                .section-subtitle
                                    span.line
                                    | You can find us at
                                .section-content
                                    p.contact-info
                                        | 27 George Stohmarr Street, #[br]
                                        | Brooklyn, #[br]
                                        | Pretoria Central, 0122 #[br]
                                        | South Africa
                                .spacer
                                .section-subtitle
                                    span.line
                                    | Contact us
                                .section-content
                                    a.contact-info-link(
                                        href="mailto:hello@influx.studio"
                                    ) hello@influx.studio
                                    a.contact-info-link(
                                        href="tel:+27 12 345 6789"
                                    ) +27 12 345 6789
                                .spacer
                                .section-subtitle
                                    span.line
                                    | Follow our journey
                                .section-content
                                    a.contact-info-social(
                                        href="https://www.facebook.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/facebook.svg")
                                    a.contact-info-social(
                                        href="https://www.twitter.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/twitter.svg")
                                    a.contact-info-social(
                                        href="https://www.instagram.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/insta.svg")
                                    a.contact-info-social(
                                        href="https://www.linkedin.com",
                                        data-cursor-shrink,
                                        target="_blank"
                                    )
                                        img(src="@/assets/linkedin.svg")
                            VCol(:variants="['xs-12', 'md-6']") 
                                .section-content.min-content.remove-top-margin
                                    .contact-form-card
                                        img.dot-pattern(
                                            src="@/assets/dot-pattern.svg"
                                        )
                                        .section-subtitle
                                            span.line
                                            | Send us a message
                                        ContactForm
                .section-gridlines
</template>

<script>
import HomeBanner from "@/components/home-banner/home-banner.vue";
import StaticElements from "@/components/home-static-elements.vue";
import ContactForm from "@/components/contactform.vue";
import Parallax from "parallax-js";
import DisplacementImage from "@/components/displacement-image.vue";
import { EventBus } from "@/events/global-bus.js";
import TabbedView from "@/components/tabbed-information.vue";
import VueSlickCarousel from "vue-slick-carousel";
// require("vue-slick-carousel/dist/vue-slick-carousel.css");
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: "Home",
    metaInfo: {
        title: "Home",
    },
    components: {
        HomeBanner,
        StaticElements,
        DisplacementImage,
        TabbedView,
        VueSlickCarousel,
        ContactForm,
    },
    data: function () {
        return {
            fpOptions: {
                licenceKey: "",
                // menu: "#menu",
                onLeave: this.changedSlide,
                navigation: true,
                navigationTooltips: [
                    "Landing",
                    "About",
                    "Services",
                    "Projects",
                    "The Team",
                    "Contact us",
                ],
                lockAnchors: true,
                scrollHorizontally: true,
                responsiveWidth: 1280,
            },
            fullpageDots: null,
            isAtTop: true,
            isAtBottom: false,
        };
    },
    methods: {
        changedSlide(origin, destination) {
            // if (destination.index == 1 && direction == "down") {
            //     // Hide navigation
            //     this.fullpageDots.classList.remove("hidden");
            //     this.isAtTop = false;
            // }

            // if (destination.index == 0 && direction == "up") {
            //     // Show navigation
            //     this.fullpageDots.classList.add("hidden");
            //     this.isAtTop = true;
            // }

            // if (destination.index == 4 && direction == "down") {
            //     this.isAtBottom = true;
            // }

            if (destination.index > 0) this.isAtTop = false;
            else this.isAtTop = true;

            if (destination.index < 5) this.isAtBottom = false;
            else this.isAtBottom = true;

            if (destination.index == 0)
                this.fullpageDots.classList.add("hidden");
            else this.fullpageDots.classList.remove("hidden");
        },
        BackToTop() {
            this.$refs.fullpage.api.moveTo("landing", 0);
        },
        SlideUp() {
            this.$refs.fullpage.api.moveSectionUp();
        },
        SlideDown() {
            this.$refs.fullpage.api.moveSectionDown();
        },
        nextTeamMember() {
            this.$refs.teamsCarousel.next();
        },
        prevTeamMember() {
            this.$refs.teamsCarousel.prev();
        },
        scrollTo(name) {
            this.$refs.fullpage.api.moveTo(name, 0);
        },
    },
    mounted() {
        this.fullpageDots = document.getElementById("fp-nav");
        this.fullpageDots.classList.add("hidden");

        new Parallax(this.$refs.parallax1, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        new Parallax(this.$refs.parallax2, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        let scrollParam = this.$route.query.c;
        if (scrollParam != null && scrollParam != undefined) {
            if (scrollParam == true) {
                this.scrollTo("contact");
            }
        }

        EventBus.$emit("rescan-cursor");
        EventBus.$on("scrollToContactForm", () => {
            this.scrollTo("contact");
        });
        EventBus.$on("scrollAbout", () => {
            this.scrollTo("about");
        });
    },
};
</script>

<style lang="scss">
.section {
    position: relative;
}
.section-gridlines {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        to right,
        transparentize(#575757, 0.9),
        transparentize(#575757, 0.9) 1px,
        $cl-cream 1px,
        $cl-cream 10%
    );
    z-index: 0;

    @include respond-below(lg) {
        background: repeating-linear-gradient(
            to right,
            transparentize(#575757, 0.9),
            transparentize(#575757, 0.9) 1px,
            $cl-cream 1px,
            $cl-cream 25%
        );
    }
}

.section-wrapper {
    width: 100%;
    height: 100%;
    background-color: $cl-cream;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    position: relative;
    z-index: 2;

    @include respond-below(lg) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
    }

    .section-inner-wrapper {
        position: relative;
        z-index: 2;
        // display: flex;
        align-items: center;
        max-width: 120rem;
        width: 100%;
        .section-title {
            color: $cl-red;
            font-size: 4.8rem;
            line-height: 1.2em;

            @include respond-below(lg) {
                font-size: 3.6rem;
            }
        }

        .section-image {
            // margin-right: 16rem;
            max-width: 28rem;
            position: relative;
            .main-image {
                max-width: 28rem;
                position: relative;
                z-index: 3;
            }

            .dot-pattern {
                position: absolute;
                max-width: 28rem;
                margin-left: 3.6rem;
                margin-top: 3.6rem;
                z-index: 1;
            }

            .outline-square {
                position: absolute;
                width: 75%;
                height: 100%;
                border: 1px solid $cl-grey;
                margin-top: -3.6rem;
                margin-left: -3.6rem;
                z-index: 1;
            }

            .filled-squares {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    width: 9.6rem;
                    height: 9.6rem;
                    bottom: -2.4rem;
                    right: -2.4rem;
                    background-color: $cl-red;
                }

                &::after {
                    content: "";
                    position: absolute;
                    width: 16rem;
                    height: 16rem;
                    top: -3.6%;
                    left: -3.6rem;
                    border: 1px solid $cl-grey;
                }
            }

            @include respond-below(lg) {
                max-width: none;
                margin-top: 3.6rem;
                .main-image {
                    max-width: 26rem;
                    margin: 0 auto;
                }

                .dot-pattern {
                    margin-left: 20%;
                    margin-top: 5%;
                }

                .outline-square {
                    margin-top: -2.8rem;
                    margin-left: 0;
                    height: 80%;
                }

                .filled-squares {
                    &::before {
                        width: 7.2rem;
                        height: 7.2rem;
                        bottom: 1.6rem;
                        right: 1.6rem;
                    }

                    &::after {
                        top: -2.8rem;
                        left: 1rem;
                    }
                }

                padding-bottom: 4.8rem;
            }
        }

        .section-content-wrapper {
            // margin-left: 12rem;
            margin-top: 4.8rem;

            &.twocolumns {
                display: flex;

                .column:not(:last-child) {
                    margin-right: 12rem;
                }

                .section-content {
                    max-width: 41rem;
                }
            }

            .spacer {
                height: 6.4rem;

                @include respond-below(lg) {
                    display: none;
                }
            }

            .section-content {
                margin-left: 6.8rem;
                margin-top: 1.6rem;
                font-weight: 500;
                font-size: 1.8rem;
                max-width: 64rem;

                @include respond-below(lg) {
                    margin-left: 0;
                }

                &.min-content {
                    min-width: 41rem;

                    @include respond-below(lg) {
                        min-width: 0;
                    }
                }

                &.remove-top-margin {
                    margin-top: 0;
                }

                p {
                    &:not(:first-child) {
                        margin-top: 2rem;
                    }
                }

                ul {
                    list-style-type: none;
                    margin: 0;

                    li:not(:last-child) {
                        margin-bottom: 0.4em;
                    }

                    li.hidden {
                        visibility: hidden;
                    }

                    @include respond-below(lg) {
                        margin-bottom: 3.6rem;

                        li.hidden {
                            display: none;
                        }
                    }
                }

                .contact-info {
                    line-height: 1.8;
                }

                .contact-info-link {
                    display: block;

                    &:not(:last-child) {
                        margin-bottom: 0.4em;
                    }
                }

                .contact-info-social {
                    &:hover {
                        img {
                            opacity: 1;
                        }
                    }
                    img {
                        width: 3.2rem;
                        height: 3.2rem;
                        opacity: 0.75;
                        transition: opacity 200ms ease-in-out;
                    }

                    &:not(:last-child) {
                        margin-right: 1rem;
                    }
                }

                .service-list {
                    margin-top: 4.8rem;
                    .service-item {
                        font-size: 2.8rem;
                        font-family: "Poppins", Helvetica, sans-serif;
                        font-weight: 700;
                        position: relative;
                        padding-left: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        &:not(:last-child) {
                            margin-bottom: 1.8rem;
                        }

                        a.label:hover + .lnr {
                            margin-left: 2rem;
                            opacity: 1;
                        }

                        .lnr {
                            font-size: 2.1rem;
                            line-height: 2.1rem;
                            position: relative;
                            color: $cl-grey;
                            margin-left: 1rem;
                            opacity: 0;
                            transition: opacity 200ms ease-in-out,
                                margin-left 200ms ease-in-out;
                        }

                        span.numbering {
                            font-size: 0.6em;
                            position: absolute;
                            left: 0;
                            top: 0;
                            line-height: 1.2em;
                            color: $cl-cream-darker;
                            font-weight: 600;
                            display: inline-block;
                            text-align: right;
                            width: 2rem;
                        }

                        .label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }
                        }
                    }
                }
            }

            .contact-form-card {
                background-color: $cl-cream;
                border: 1px solid $cl-cream-darker;
                box-sizing: border-box;
                padding: 2rem;
                width: 100%;
                box-sizing: border-box;

                @include respond-below(lg) {
                    margin-top: 3.6rem;
                }

                .section-subtitle {
                    margin-bottom: 2.4rem;
                    margin-left: -5.2rem;

                    @include respond-below(lg) {
                        display: none;
                    }
                }

                .dot-pattern {
                    position: absolute;
                    bottom: -3.2rem;
                    right: -3.2rem;
                    z-index: -1;
                    @include respond-below(lg) {
                        display: none;
                    }
                }
            }

            .section-subtitle {
                display: flex;
                align-items: center;
                font-weight: 700;
                font-size: 1.8rem;
                .line {
                    box-sizing: border-box;
                    width: 4.8rem;
                    height: 1px;
                    margin-top: 0.2em;
                    margin-right: 2rem;
                    background-color: $cl-grey;

                    @include respond-below(lg) {
                        display: none;
                    }
                }
            }
        }
    }
}

.static-navigation-buttons {
    display: flex;
    flex-flow: column nowrap;
    position: fixed;
    bottom: $body-padding-desktop-y;
    right: $body-padding-desktop-x;
    z-index: 99;

    span {
        width: 4.8rem;
        height: 4.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.8rem;
        color: $cl-grey;
    }

    .navbutton,
    .back-to-top {
        transition: opacity 300ms ease-in-out;
        cursor: pointer;
    }

    .navbutton.hidden,
    .back-to-top.hidden {
        opacity: 0;
        pointer-events: none;
    }

    .back-to-top {
        position: relative;
        width: 4.8rem;
        height: 4.8rem;
        span {
            position: absolute;
            top: 0;

            &:nth-child(1) {
                transform: translateY(-10%);
            }

            &:nth-child(2) {
                transform: translateY(10%);
            }
        }
    }
}
.featured-works-section {
    width: 100%;
    //padding: $body-padding-desktop-y $body-padding-desktop-x;

    @include respond-below(lg) {
        .v-col:not(:last-child) {
            margin-bottom: 9.6rem;
        }
    }

    .featured-work-image-wrapper {
        position: relative;
        .displacement-image-wrapper {
            position: relative;
            z-index: 2;
        }

        .outline-square.square-1 {
            position: absolute;
            border: 1px solid $cl-grey;
            width: 60%;
            height: 80%;
            top: -2.8rem;
            left: -2.8rem;
        }

        .filled-square.square-1 {
            position: absolute;
            background-color: $cl-red;
            width: 6.4rem;
            height: 6.4rem;
            bottom: -2.8rem;
            right: -2.8rem;
            z-index: 1;
        }

        .dot-pattern {
            position: absolute;
            width: auto;
            height: 100%;
            bottom: -2.8rem;
            right: -2.8rem;
        }

        .outline-square.square-2 {
            position: absolute;
            border: 1px solid $cl-grey;
            width: 60%;
            height: 60%;
            top: -2.8rem;
            left: -2.8rem;
        }

        .outline-square.square-3 {
            position: absolute;
            border: 1px solid $cl-grey;
            width: 30%;
            height: 30%;
            top: -2.8rem;
            left: -2.8rem;
        }

        .outline-square.square-4 {
            position: absolute;
            border: 1px solid $cl-grey;
            width: 30%;
            height: 30%;
            bottom: 2.8rem;
            right: -2.8rem;
        }

        .filled-square.square-2 {
            position: absolute;
            background-color: $cl-red;
            width: 6.4rem;
            height: 6.4rem;
            bottom: 20%;
            left: -1.4rem;
            z-index: 1;
        }

        @include respond-below(lg) {
            padding: 0 $body-padding-mobile-x;

            .outline-square.square-1 {
                width: 80%;
                height: 80%;
                top: -$body-padding-mobile-x;
                left: 0;
            }

            .filled-square.square-1 {
                position: absolute;
                background-color: $cl-red;
                width: 6.4rem;
                height: 6.4rem;
                bottom: -$body-padding-mobile-x;
                right: 0;
                z-index: 1;
            }

            .dot-pattern {
                position: absolute;
                width: auto;
                height: 100%;
                bottom: -$body-padding-mobile-x;
                right: 0rem;
            }

            .outline-square.square-2 {
                position: absolute;
                border: 1px solid $cl-grey;
                width: 60%;
                height: 60%;
                top: -$body-padding-mobile-x;
                left: 0;
            }

            .outline-square.square-3 {
                position: absolute;
                border: 1px solid $cl-grey;
                width: 30%;
                height: 30%;
                top: -$body-padding-mobile-x;
                left: 0;
            }

            .outline-square.square-4 {
                position: absolute;
                border: 1px solid $cl-grey;
                width: 30%;
                height: 30%;
                bottom: 3.6rem;
                right: 0;
            }

            .filled-square.square-2 {
                position: absolute;
                background-color: $cl-red;
                width: 6.4rem;
                height: 6.4rem;
                bottom: 20%;
                left: 0;
                z-index: 1;
            }
        }
    }

    .v-row {
        justify-content: space-between;
    }

    .v-col {
        max-width: 28%;
        @include respond-below(lg) {
            max-width: none;
        }
    }

    .featured-work-details {
        //max-width: 32rem;
        margin-top: 4.8rem;
        .featured-work-subtitle {
            font-family: "Muli", sans-serif;
            font-weight: 600;
            font-size: 1.6rem;
            margin-bottom: 1rem;
        }

        .featured-work-title {
            font-family: "Poppins", sans-serif;
            font-family: 700;
            font-size: 2.4rem;
        }
    }

    .displacement-injector {
        width: 100%;
        height: 100%;
        // canvas {
        //     width: 100% !important;
        //     height: auto !important;
        // }
    }
}

.section-title-with-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 2.8rem;

    @include respond-below(lg) {
        display: block;
        .primary-button {
            margin-top: 1.6rem;
        }
    }
}

.team-section {
    font-weight: 500;

    @include respond-below(lg) {
        .section-inner-wrapper {
            // padding: 0 $body-padding-mobile-x;
            margin: 0;
            box-sizing: border-box;
            width: 100%;
        }
    }

    .section-inner-wrapper {
        align-items: flex-start;
    }

    .section-content-container {
        padding-left: 7.2rem;

        @include respond-below(lg) {
            padding-left: 0;
        }
    }

    .team-image {
        position: relative;
        max-width: 32rem;

        @include respond-below(lg) {
            max-width: none;
        }

        .bg {
            position: absolute;
            left: 0;
            width: 100%;
            bottom: -2rem;
            z-index: -1;
        }

        .person {
            position: relative;
            width: 28rem;
            height: auto;
            display: block;
            margin: 0 auto;
        }
    }

    .team-person-details {
        margin-top: 6.4rem;
        h3 {
            font-size: 2.4rem;
        }
        h4 {
            font-weight: 500;
            font-size: 1.8rem;
        }
    }

    .team-person-contacts {
        margin-top: 2.4rem;

        a {
            display: block;
            font-size: 1.8rem;
            font-weight: 500;

            &:not(:last-child) {
                margin-bottom: 0.2em;
            }
        }
    }

    .team-person-socials {
        margin-top: 2.4rem;
        a {
            display: inline-block;
            img {
                width: 2.4rem;
                height: 2.4rem;
            }

            &:not(:last-child) {
                margin-right: 1em;
            }
        }
    }

    .team-person-description {
        font-size: 1.8rem;
        margin-top: 2.4rem;
    }

    .team-person-quote {
        font-size: 1.8rem;
        position: relative;
        font-style: italic;

        &::before {
            content: "";
            position: absolute;
            top: -1.6rem;
            left: -1.6rem;
            background-image: url("~@/assets/quote.svg");
            background-size: contain;
            background-repeat: no-repeat;
            width: 4.2rem;
            height: 4.2rem;
        }
    }

    .tabbed-view {
        margin-top: 4.8rem;
    }

    .team-navigation-links {
        display: flex;
        align-items: center;
        margin-left: -1.2rem;
        margin-top: 2.8rem;
        justify-content: space-between;

        .team-navigation-indicator {
            display: flex;
            align-items: center;
            .number {
                font-size: 1.6rem;
                font-weight: 500;
            }

            .divider {
                font-size: 3.2rem;
                font-weight: 300;
                padding: 0 1rem;
            }
        }

        .team-prev,
        .team-next {
            width: 4.8rem;
            height: 4.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 2.8rem;
            color: $cl-grey;
            cursor: pointer;
            transition: color 150ms ease-in-out;
        }

        .team-prev {
            margin-right: 1rem;
        }
    }
}

@keyframes listItemIn {
    from {
        transform: translateX(-2rem);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.skill-list {
    list-style-type: none;
    li {
        padding-left: 3rem;
        position: relative;
        animation-name: "listItemIn";
        animation-duration: 250ms;
        animation-timing-function: ease-in-out;
        animation-fill-mode: forwards;
        transform: translateX(-2rem);
        opacity: 0;
        margin-bottom: 0.4rem;

        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0.75em;
            background-color: $cl-grey;
            height: 1px;
            width: 1.1rem;
        }

        &.hidden {
            display: none;
            &::before {
                display: none;
            }
        }

        // &::after {
        //     content: "";
        //     position: absolute;
        //     left: 0.5rem;
        //     top: 0;
        //     background-color: $cl-grey;
        //     height: 1.1rem;
        //     width: 1px;
        // }

        // &::before,
        // &::after {
        //     transform: translateY(0.5em);
        // }
    }
}

.slick-slider,
.slick-list,
.slick-track,
.slick-slide,
.slick-slide > div,
.slick-slide > div > .team-section {
    height: 100%;
}

.slick-slider {
    position: relative;
    .slick-arrow {
        position: absolute;
        top: 50%;
        z-index: 99;
        &.slick-prev {
            left: 10px;
        }
        &.slick-next {
            right: 10px;
        }
    }
}

@include respond-below(lg) {
    .static-navigation-buttons {
        display: none;
    }

    .section-content-container {
        margin-top: 2.8rem;
    }
}
</style>